import { render, staticRenderFns } from "./ModalVisualizarLaudosVinculados.vue?vue&type=template&id=4d47636a&lang=pug"
import script from "./ModalVisualizarLaudosVinculados.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarLaudosVinculados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports